export const simTokens = {
  shell: 'min-h-screen bg-surface-page text-txt-primary px-4 py-6 md:px-6 md:py-8',
  header:
    'bg-surface-card border border-line rounded-card shadow-card p-4 md:p-[22px]',
  card:
    'bg-surface-card border border-line rounded-card shadow-card p-4 md:p-[22px]',
  label: 'text-overline font-bold text-txt-muted',
  title: 'text-page-title font-display font-bold text-txt-primary',
  body: 'text-[15px] md:text-body leading-relaxed text-txt-secondary font-body',
  muted: 'text-small leading-relaxed text-txt-muted',
  divider: 'border-t border-line-subtle',
  headerAccentLabel: 'text-overline font-bold text-brand-600',
  buttonPrimary:
    'iv-btn-primary',
  badgeBase:
    'inline-flex items-center rounded-badge border px-2.5 py-1 text-badge font-bold uppercase tracking-[0.12em]',
  badgeNeutral: 'border-line bg-surface-card text-txt-secondary',
  badgeFlag: 'border-line bg-surface-alt text-txt-secondary',
  badgeIntegrityHigh: 'border-success/30 bg-success-light text-success-text',
  badgeIntegrityMedium: 'border-copper-600/30 bg-copper-50 text-copper-700',
  badgeIntegrityLow: 'border-danger/30 bg-danger-light text-danger-text',
  badgeEvidenceCorrect:
    'border-success/30 bg-success-light px-2 py-0.5 text-[10px] tracking-[0.16em] text-success-text',
  badgeEvidenceIncorrect:
    'border-danger/30 bg-danger-light px-2 py-0.5 text-[10px] tracking-[0.16em] text-danger-text',
} as const;

export type SimTokenName = keyof typeof simTokens;
